"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const detect_utils_1 = require("@/common/detect_utils");
function default_1(dependency = true) {
    (0, react_1.useEffect)(() => {
        if (!detect_utils_1.isLocalhost && dependency) {
            window.onbeforeunload = function (event) {
                event.preventDefault();
                return '';
            };
            return () => {
                window.onbeforeunload = null;
            };
        }
    }, [dependency]);
}
exports.default = default_1;
